export default function Divider() {
  return (
    <div
      style={{
        height: 0,
        width: 0,
        overflow: "hidden",
        breakAfter: "page",
      }}
    />
  );
}
